import { useConnect } from '@lore/query-connect';
import {partnerResponses} from '@/pages/dashboard-year/Events/_invitationDeclineReasons';
import { event_networkId } from '@/utils/query-helpers';

export default function useEventInvitationsResponded(network, timestamp) {
  return useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          ...event_networkId(network),
          createdAt: {
            $gte: timestamp.start,
            $lte: timestamp.end
          },
          $or: [
            {
              response: 'Yes'
            },
            {
              response: 'Maybe'
            }
          ].concat(partnerResponses.map(function(response) {
            return {
              response: 'No',
              responseMessage: {
                $ilike: `%${response}%`
              }
            }
          }))
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
